import { ROLES } from 'variables';
import { lazy } from 'react';

// project import
import Loadable from 'components/@ui/loader/Loadable';

// PROGRAMS
const Programs = Loadable(lazy(() => import('pages/commons/prgoram-management/Programs')));
const Program = Loadable(lazy(() => import('pages/commons/prgoram-management/program-details/ProgramDetailsPage')));
const Offer = Loadable(lazy(() => import('pages/commons/offer-management/offer-details/OfferDetails')));
const CreateOffer = Loadable(lazy(() => import('pages/commons/offer-management/offer-creation/OfferCreationPage')));

const Plan = Loadable(lazy(() => import('pages/commons/distribution-plan-management/distribution-plan-details/DistributionPlanDetails')));

const PlanAllocation = Loadable(lazy(() => import('pages/commons/license-management/license-allocation/LicenseAllocation')));

const ProgramCreationPage = Loadable(lazy(() => import('pages/commons/prgoram-management/program-creation/ProgramCreationPage')));

const SponsorshipsCreationPage = Loadable(
  lazy(() => import('pages/commons/sponsorships-management/sponsorships-creation/SponsorshipsCreationPage'))
);

// CATEGORIES
const Categories = Loadable(lazy(() => import('pages/commons/categories-management/categories-listing/CategoriesTable')));

const Category = Loadable(lazy(() => import('pages/commons/categories-management/category-details/CategoryDetailsPage')));

const CategoryCreationPage = Loadable(lazy(() => import('pages/commons/categories-management/categories-creation/CategoryCreationPage')));

// MERCHANTS
const Merchants = Loadable(lazy(() => import('pages/commons/merchant-management/merchants-listing/MerchantsTable')));

const MerchantCreationPage = Loadable(lazy(() => import('pages/commons/merchant-management/merchant-creation/MerchantCreationPage')));

// ORGANIZATIONS
const Organizations = Loadable(lazy(() => import('pages/commons/organizations-management/organizations-listing/OrganizationsTable')));

// LICENSES
const LicenseList = Loadable(lazy(() => import('pages/commons/ma-license-management/licenses/listing/LicensesTable')));
const LicenseTypes = Loadable(lazy(() => import('pages/commons/ma-license-management/license-types/listing/LicenseTypesTable')));

// EMPLOYEES
const Employees = Loadable(lazy(() => import('pages/commons/employee-management/employees/Employees')));
const Employee = Loadable(lazy(() => import('pages/commons/employee-management/employees/employee-details/EmployeeDetails')));
const EmployeeGroups = Loadable(lazy(() => import('pages/commons/employee-management/employee-groups/EmployeeGroups')));
const EmployeeGroup = Loadable(
  lazy(() => import('pages/commons/employee-management/employee-groups/employee-groups-details/EmployeeGroupsDetails'))
);
const AddEmployees = Loadable(lazy(() => import('pages/commons/employee-management/employees/employee-creation/CreateEmployeePage')));
const AddEmployeeGroup = Loadable(
  lazy(() => import('pages/commons/employee-management/employee-groups/employee-group-creation/EmployeeGroupCreatonPage'))
);

// FINANCIALS
const Financials = Loadable(lazy(() => import('pages/commons/financial-management/Financials')));
const Wallets = Loadable(lazy(() => import('pages/commons/financial-management/wallet-management/WalletPage')));
const AddWalletFunds = Loadable(lazy(() => import('pages/commons/financial-management/wallet-management/wallet-funding/FundWalletPage')));
const Transactions = Loadable(lazy(() => import('pages/commons/financial-management/transaction-management/Transactions')));
const Transaction = Loadable(
  lazy(() => import('pages/commons/financial-management/transaction-management/transaction-details/TransactionDetailsPage'))
);
const Payments = Loadable(lazy(() => import('pages/commons/financial-management/payments-management/payments-listing/PaymentsTable')));
const Settlements = Loadable(lazy(() => import('pages/commons/settlement-management/settlement-listing/SettlementsTable')));
const Settlement = Loadable(lazy(() => import('pages/commons/settlement-management/settlement-details/SettlementDetailsPage')));
const Receivables = Loadable(lazy(() => import('pages/commons/financial-management/receivables-management/listing/ReceivablesTable')));
const Receivable = Loadable(lazy(() => import('pages/commons/financial-management/receivables-management/details/ReceivablesDetailsPage')));
const ReceivableSettlements = Loadable(lazy(() => import('pages/commons/recievables-management/settlements/listing/RecSettlementsTable')));
const ReceivableSettlement = Loadable(lazy(() => import('pages/commons/recievables-management/settlements/details/RecSettlementPage')));
const Charges = Loadable(lazy(() => import('pages/commons/financial-management/charge-management/ChargesPage')));
const ChargeComponentCreationPage = Loadable(
  lazy(() => import('pages/commons/financial-management/charge-management/charge-components/creation/ChargeComponentCreationPage'))
);
const ChargeGroupCreationPage = Loadable(
  lazy(() => import('pages/commons/financial-management/charge-management/charge-groups/creation/ChargeGroupCreationPage'))
);
const ChargeGroup = Loadable(
  lazy(() => import('pages/commons/financial-management/charge-management/charge-groups/details/ChargeGroupDetailsPage'))
);

// FINANCIALS
const Licenses = Loadable(lazy(() => import('pages/commons/license-management/license-allocation/LicenseAllocation')));
const LicenseGenerations = Loadable(lazy(() => import('pages/commons/license-management/license-generation/LicesneGeneration')));

// CLAIMS
const Claims = Loadable(lazy(() => import('pages/commons/claims-management/listing/ClaimsTable')));

// Campaigns/Events
const Campaigns = Loadable(lazy(() => import('pages/commons/event-management/event-listing/EventsTable')));
const CampaignCreation = Loadable(lazy(() => import('pages/commons/event-management/event-creation/EventCreationPage')));

// BUSINESS TYPES
const BusinessTypes = Loadable(lazy(() => import('pages/commons/business-types-management/BusinessTypes')));

// SUPPORT
// const Support = Loadable(lazy(() => import('pages/common/support/SupportForm')));
const Support = Loadable(lazy(() => import('pages/common/support/Support')));

// TEST
const Test = Loadable(lazy(() => import('pages/commons/employee-management/employees/employee-details/EmployeeDetailPage')));
// const Support = Loadable(lazy(() => import('components/widgets/components/TimelineWidget')));

// SIMULATOR
const Simulator = Loadable(lazy(() => import('pages/simulator/Simulator')));

// NFC DEVICES
const SKUs = Loadable(lazy(() => import('pages/commons/device-management/skus/listing/SkusTable')));
const DeviceCategories = Loadable(lazy(() => import('pages/commons/device-management/categories/listing/DeviceCategoriesTable')));
const Lots = Loadable(lazy(() => import('pages/commons/device-management/lots/listing/LotsTable')));

// assets
import CampaignIcon from '@mui/icons-material/Campaign';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CalculateIcon from '@mui/icons-material/Calculate';
import ReceiptIcon from '@mui/icons-material/Receipt';
import GroupsIcon from '@mui/icons-material/Groups';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import FestivalOutlinedIcon from '@mui/icons-material/FestivalOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import TapAndPlayIcon from '@mui/icons-material/TapAndPlay';
import { TabletSmartphone } from 'lucide-react';
// icons
const icons = {
  CampaignIcon,
  HandshakeOutlinedIcon,
  StorefrontIcon,
  CalculateIcon,
  ReceiptIcon,
  GroupsIcon,
  VolunteerActivismIcon,
  PaymentIcon,
  AccountBalanceWalletIcon,
  TabletSmartphone,
  ReceiptLongOutlinedIcon,
  FestivalOutlinedIcon,
  CategoryOutlinedIcon,
  StorefrontOutlinedIcon,
  WorkspacePremiumIcon,
  BusinessIcon,
  LocalMallOutlinedIcon,
  TapAndPlayIcon
  // Add more icons as needed
};

//======================= VASEELAH ADMIN ROUTES ===================================//
export const commonsRoutes = [
  // BENEFICIARIES
  {
    path: 'employees',
    element: <Employees />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'employees/add',
    element: <AddEmployees />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'employees/:employeeId',
    element: <Test />,
    // element: <></>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'employees/employee-groups',
    element: <EmployeeGroups />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'employees/employee-groups/new',
    element: <AddEmployeeGroup />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'employees/employee-groups/:groupKey',
    element: <EmployeeGroup />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'employees/activation-codes',
    element: <h1>Programs</h1>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // PROGRAMS
  {
    path: 'programs',
    element: <Programs />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'programs/:programId',
    element: <ProgramCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'programs/:programId/details',
    element: <Program />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'programs/:programId/details/plan/:planId',
    element: <Offer />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'programs/:programId/details/plan/:planId/sponsorships/new',
    element: <SponsorshipsCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'programs/:programId/details/plan/:planId/employee/:employeeId',
    element: <Employee />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  // Categories
  {
    path: 'categories',
    element: <Categories />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'categories/new',
    element: <CategoryCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'categories/:categoryId',
    element: <Category />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // Merchants
  {
    path: 'merchants',
    element: <Merchants />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'merchants/new',
    element: <MerchantCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // Business Types
  {
    path: 'business-types',
    element: <BusinessTypes />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // Organizations
  {
    path: 'organizations',
    element: <Organizations />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'organizations/:orgKey',
    element: <>Org</>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // Licenses
  {
    path: 'licenses/list',
    element: <LicenseList />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'licenses/types',
    element: <LicenseTypes />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // Campaigns/Events
  {
    path: 'campaigns',
    element: <Campaigns />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'campaigns/new',
    element: <CampaignCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // FINANTIAL PERFORMANCE
  {
    path: 'financials',
    element: <Financials />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/transactions',
    element: <Transactions />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/transactions/:transactionId',
    element: <Transaction />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/payments',
    element: <Payments />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/payments/:transId',
    element: <Payments />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/program-accounts',
    element: <Wallets />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/program-accounts/:walletAddress',
    element: <AddWalletFunds />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/program-accounts/:walletAddress/transactions',
    element: <Transactions />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/settlements',
    element: <Settlements />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/settlements/:settlementId',
    element: <Settlement />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // CHARGES
  {
    path: 'financials/charges',
    element: <Charges />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/charges/component/new',
    element: <ChargeComponentCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/charges/group/new',
    element: <ChargeGroupCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/charges/group/:chargeCode',
    element: <ChargeGroup />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/charges/group/:chargeCode/edit',
    element: <ChargeGroupCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/charges/group/new',
    element: <Charges />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // RECEIVABLES
  {
    path: 'financials/receivables',
    element: <Receivables />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/receivables/:recId',
    element: <Receivable />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'receivable/settlements',
    element: <ReceivableSettlements />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'receivable/settlements/:settlementId',
    element: <ReceivableSettlement />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // FINANTIAL PERFORMANCE
  // {
  //   path: 'licenses',
  //   element: <Licenses />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },
  // {
  //   path: 'licenses/generate',
  //   element: <LicenseGenerations />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },

  // CLAIMS
  {
    path: 'claims',
    element: <Claims />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // SUPPORT
  {
    path: 'support',
    element: <Support />,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // SIMULATOR
  {
    path: 'simulator',
    element: <Simulator />,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // NFC DEVICES
  {
    path: 'nfc-devices/brands',
    element: <>Brands</>,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'nfc-devices/skus',
    element: <SKUs />,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'nfc-devices/categories',
    element: <DeviceCategories />,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'nfc-devices/suppliers',
    element: <>Suppliers</>,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'nfc-devices/lots',
    element: <Lots />,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'nfc-devices/ownerships',
    element: <>Ownerships</>,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  }
];

//=============================== PRISEEN COMMONS MENU ITEMS===============================//

export const commonsMenuItems = [
  // {
  //   id: 'deal-managemet',
  //   title: 'Deals',
  //   type: 'item',
  //   url: '/deals',
  //   icon: icons.CampaignIcon,
  //   breadcrumbs: true,
  //   feature_code: 'deal-management'
  // },
  {
    id: 'programs',
    title: 'Programs',
    type: 'item',
    url: '/programs',
    icon: icons.CampaignIcon,
    breadcrumbs: true,
    feature_code: 'programs'
  },

  {
    id: 'categories',
    title: 'Categories',
    type: 'item',
    url: '/categories',
    icon: icons.CategoryOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'categories'
  },

  {
    id: 'organizations',
    title: 'Organizations',
    type: 'item',
    url: '/organizations',
    icon: icons.BusinessIcon,
    breadcrumbs: true,
    feature_code: 'organizations'
  },

  {
    id: 'merchants',
    title: 'Merchants',
    type: 'item',
    url: '/merchants',
    icon: icons.StorefrontOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'merchants'
  },

  {
    id: 'receivables',
    title: 'Receivables',
    type: 'collapse',
    url: '/receivables',
    icon: icons.CalculateIcon,
    breadcrumbs: true,
    feature_code: 'receivables-management',
    children: [
      {
        id: 'receivable-settlements',
        title: 'Settlements',
        type: 'item',
        url: '/receivable/settlements',
        breadcrumbs: true,
        feature_code: 'receivables-management'
      }
    ]
  },
  {
    id: 'financials',
    title: 'Financials',
    type: 'collapse',
    url: '/financials',
    icon: icons.CalculateIcon,
    breadcrumbs: true,
    feature_code: 'financial-management',
    children: [
      // {
      //   id: 'charges',
      //   title: 'Charges',
      //   type: 'collapse',
      //   url: '/financials/charges',
      //   // icon: icons.CalculateIcon,
      //   breadcrumbs: true,
      //   feature_code: 'financial-management',
      //   level: 2,
      //   children: [
      //     {
      //       id: 'charge-groups',
      //       title: 'Charge Groups',
      //       type: 'item',
      //       url: '/financials/charges/groups',
      //       breadcrumbs: true,
      //       feature_code: 'financial-management'
      //     },
      //     {
      //       id: 'charge-components',
      //       title: 'Charge Components',
      //       type: 'item',
      //       url: '/financials/charges/components',
      //       breadcrumbs: true,
      //       feature_code: 'financial-management'
      //     }
      //   ]
      // },
      {
        id: 'charges',
        title: 'Charges',
        type: 'item',
        url: '/financials/charges',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'receivables',
        title: 'Receivables',
        type: 'item',
        url: '/financials/receivables',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'settlements',
        title: 'Settlements',
        type: 'item',
        url: '/financials/settlements',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'wallets',
        title: 'Program Accounts',
        type: 'item',
        url: '/financials/program-accounts',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'transactions',
        title: 'Transactions',
        type: 'item',
        url: '/financials/transactions',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'payments',
        title: 'Payments',
        type: 'item',
        url: '/financials/payments',
        breadcrumbs: true,
        feature_code: 'financial-management'
      }
    ]
  },

  {
    id: 'nfc-devices',
    title: 'NFC Device Management',
    type: 'collapse',
    url: '/nfc-devices',
    icon: icons.TapAndPlayIcon,
    breadcrumbs: true,
    feature_code: 'nfc-device-management',
    children: [
      {
        id: 'nfc-devices',
        title: 'Brands',
        type: 'item',
        url: '/nfc-devices/brands',
        breadcrumbs: true,
        feature_code: 'nfc-device-management'
      },
      {
        id: 'nfc-device-categories',
        title: 'Categories',
        type: 'item',
        url: '/nfc-devices/categories',
        breadcrumbs: true,
        feature_code: 'nfc-device-management'
      },
      {
        id: 'nfc-device-skus',
        title: 'SKUs',
        type: 'item',
        url: '/nfc-devices/skus',
        breadcrumbs: true,
        feature_code: 'nfc-device-management'
      },
      {
        id: 'nfc-device-suppliers',
        title: 'Suppliers',
        type: 'item',
        url: '/nfc-devices/suppliers',
        breadcrumbs: true,
        feature_code: 'nfc-device-management'
      },
      {
        id: 'nfc-device-lots',
        title: 'Lots',
        type: 'item',
        url: '/nfc-devices/lots',
        breadcrumbs: true,
        feature_code: 'nfc-device-management'
      },
      {
        id: 'nfc-device-ownerships',
        title: 'Ownerships',
        type: 'item',
        url: '/nfc-devices/ownerships',
        breadcrumbs: true,
        feature_code: 'nfc-device-management'
      }

      // {
      //   id: 'programs-by-consumer-group',
      //   title: 'Programs',
      //   type: 'item',
      //   url: '/employees/activation-codes',
      //   breadcrumbs: true,
      //   feature_code: 'employee-management'
      // }
    ]
  },

  {
    id: 'business-types',
    title: 'Business Types',
    type: 'item',
    url: '/business-types',
    icon: icons.LocalMallOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'business-types'
  },

  {
    id: 'licenses',
    title: 'License Management',
    type: 'collapse',
    url: '/licenses',
    icon: icons.WorkspacePremiumIcon,
    breadcrumbs: true,
    feature_code: 'license-management',
    children: [
      {
        id: 'licenses',
        title: 'List',
        type: 'item',
        url: '/licenses/list',
        breadcrumbs: true,
        feature_code: 'license-management'
      },
      {
        id: 'license-types',
        title: 'Types',
        type: 'item',
        url: '/licenses/types',
        breadcrumbs: true,
        feature_code: 'license-management'
      }
      // {
      //   id: 'programs-by-consumer-group',
      //   title: 'Programs',
      //   type: 'item',
      //   url: '/employees/activation-codes',
      //   breadcrumbs: true,
      //   feature_code: 'employee-management'
      // }
    ]
  },

  {
    id: 'campaigns',
    title: 'Events',
    type: 'item',
    url: '/campaigns',
    icon: icons.FestivalOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'campaigns'
  },

  {
    id: 'claim-management',
    title: 'Claims',
    type: 'item',
    url: '/claims',
    icon: icons.ReceiptLongOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'claim-management'
  },

  {
    id: 'employees',
    title: 'User Management',
    type: 'collapse',
    url: '/employees',
    icon: icons.GroupsIcon,
    breadcrumbs: true,
    feature_code: 'employee-management',
    children: [
      {
        id: 'employees',
        title: 'List',
        type: 'item',
        url: '/employees',
        breadcrumbs: true,
        feature_code: 'employee-management'
      },
      {
        id: 'employee-groups',
        title: 'Groups',
        type: 'item',
        url: '/employees/employee-groups',
        breadcrumbs: true,
        feature_code: 'employee-management'
      }
      // {
      //   id: 'programs-by-consumer-group',
      //   title: 'Programs',
      //   type: 'item',
      //   url: '/employees/activation-codes',
      //   breadcrumbs: true,
      //   feature_code: 'employee-management'
      // }
    ]
  },

  {
    id: 'support',
    title: 'Support',
    type: 'item',
    url: '/support',
    icon: icons.PaymentIcon,
    breadcrumbs: true,
    feature_code: 'support'
  },

  {
    id: 'simulator',
    title: 'Simulator',
    type: 'item',
    url: '/simulator',
    icon: icons.TabletSmartphone,
    breadcrumbs: true,
    feature_code: 'simulator'
  }
];
